/// <reference path="../toastr.js" />

toastr.toastConstants = {
	toastType: {
		success: "success",
		info: "info",
		warning: "warning",
		error: "error"
	},
	toastPositionCss: {
		topRight: "toast-top-right",
		bottomRight: "toast-bottom-right",
		bottomLeft: "toast-bottom-left",
		topLeft: "toast-top-left",
		topFullWidth: "toast-full-width",
		bottomFullWidth: "toast-bottom-full-width",
		topCenter: "toast-top-center",
		topCenterNoOverlap: "toast-top-centered-horizontal-nooverlap",
		bottomCenter: "toast-bottom-center"
	}
};

/**
 * A wrapper around the toastr JavaScript library: https://github.com/CodeSeven/toastr
 * @param {toastr.toastConstants} toastType the toastConstants value for the type of toast
 * @param {string} css string containing the position CSS or by default "toast-bottom-right". Valid values in toastr.toastConstants.toastPositionCss.
 * @param {string} message the toast message
 * @param {string} title the title for the toast
 * @param {object} options the options for creating the toast
 */
function Toast(toastType, css, message, title, options) {
	if (!message || !message.length) {
		return null;
	}
	this.title = title;
	this.message = message;
	this.css = css || toastr.toastConstants.toastPositionCss.bottomRight;
	this.type = toastType || toastr.toastConstants.toastType.info;
	this.isSticky = false;
	this.options = options || {
		"closeButton": false,
		"debug": false,
		"newestOnTop": true,
		"progressBar": true,
		"positionClass": this.css,
		"preventDuplicates": true,// prevent duplicates of the last toast
		"preventOpenDuplicates": true, // prevent duplicates of open toasts
		"tapToDismiss": true,
		"onclick": this.onclick,
		"showDuration": "300",
		"hideDuration": "1000",
		"timeOut": this.isSticky ? "0" : "5000",
		"extendedTimeOut": this.isSticky ? "0" : "1000",
		"showEasing": "swing",
		"hideEasing": "linear",
		"showMethod": "fadeIn",
		"hideMethod": "fadeOut"
	};
	this.makeSticky = function (trueOrFalse) {
		this.options.timeOut = trueOrFalse ? "0" : "5000";
		this.options.extendedTimeOut = trueOrFalse ? "0" : "5000";
		this.options.tapToDismiss = !trueOrFalse;
		this.isSticky = trueOrFalse;
	};
	this.setDebugLogging = function(trueOrFalse) {
		this.options.debug = trueOrFalse;
	};
	this.shownOrHiddenHandler = function() {}; // set to subscribe to toastr's published events
	this.onclick = function() { };
	this.showToast = function() {
//		toastr.options = this.options;
//		toastr.options = $.extend(true, {}, this.options);
		//toastr.options.onclick = this.onclick;
		return toastr[this.type](this.message, this.title, this.options);
		//return toast === undefined ? false : toast; // duplicates return undefined
	};
	return this;
}
